export default __webpack_public_path__ + "static/featured-properties-img2-f71afdaebb1fda29e19b0fcb2566abe4.jpg";